import { AuthOption } from "../../config/types";
import MergeLinkCardButton from "../shared/MergeLinkCardButton";

type ConnectorAuthChoiceButtonProps = {
  authOption: AuthOption;
  onClick: () => void;
};

const ConnectorAuthChoiceButton = ({ authOption, onClick }: ConnectorAuthChoiceButtonProps) => {
  return (
    // id is targeted by CustomGlobalStyle for customer border-radius overrides — do not remove
    <MergeLinkCardButton onClick={onClick} id="custom-selection-button">
      {authOption.name}
    </MergeLinkCardButton>
  );
};

export default ConnectorAuthChoiceButton;
